import { useState, useEffect } from "react";
import { Modal, Descriptions, Tag, Typography } from "antd";
import { ShowToast, Severty } from "../../helper/toast";
import moment from "moment";
import { getCity } from "../../constants/API/API";

const { Title } = Typography;

const ViewCity = ({ viewVisible, setViewVisible, selectedBelt }) => {
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedBelt) {
      setLoading(true);
      getCity(selectedBelt._id)
        .then((response) => {
          if (response.status === 200 && response.data) {
            setCity(response.data);
          }
        })
        .catch((err) => {
          ShowToast(err.message || "Failed to fetch belt data", Severty.ERROR);
        })
        .finally(() => setLoading(false));
    }
  }, [selectedBelt]);

  const handleCancel = () => {
    setViewVisible(false);
    setCity(null);
  };

  return (
    <Modal
      open={viewVisible}
      title={
        <Title level={4} style={{ margin: 0 }}>
          City Details
        </Title>
      }
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
      loading={loading}
    >
      {city && (
        <Descriptions
          bordered
          column={1}
          labelStyle={{
            fontWeight: 500,
            backgroundColor: "#fafafa",
            minWidth: "150px",
          }}
          contentStyle={{
            backgroundColor: "#fff",
          }}
        >
          <Descriptions.Item label="City Name">{city.name}</Descriptions.Item>
          <Descriptions.Item label="Status">
            {!!city.isActive ? (
              <Tag color="green">Active</Tag>
            ) : (
              <Tag color="red">InActive</Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Added On">
            {moment(city?.createdAt).format("ll")}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  );
};

export default ViewCity;
